import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {withSidePanel} from '../../../SidePanel';
import ReportIssuePanel from '../../../ReportIssuePanel';
import reportIssueMessages from '../../../ReportIssuePanel/messages';
import {injectIntl} from 'react-intl';
import {StyledButton, EscalationIcon, StyledDiv} from './styles';
import messages from './messages';

@withSidePanel
@injectIntl
@inject('store')
@observer
class ReportIssueButton extends Component {
  onReportIssueButtonClick = () => {
    this.props.pushSidePanel({
      title: this.props.intl.formatMessage(reportIssueMessages.reportIssueTitle),
      content: <ReportIssuePanel />
    });
  };

  render() {
    const {
      store,
      stepIndex,
      intl: {formatMessage},
      isMobile
    } = this.props;
    const {instructionPage, checklist} = store;
    const {currentInstruction} = instructionPage;
    const {checklist: newChecklist} = checklist;

    const currentStepId = currentInstruction.steps[stepIndex].id;
    const currentStep = newChecklist[currentStepId];
    const checkEscalated = currentStep?.checkEscalated;

    return (
      <StyledButton
        onClick={!checkEscalated ? this.onReportIssueButtonClick : undefined}
        checkEscalated={checkEscalated}
        aria-label="escalate"
        isMobile={isMobile}
      >
        <EscalationIcon isMobile={isMobile} />
        <StyledDiv isMobile={isMobile}>
          {checkEscalated ? formatMessage(messages.issueReported) : formatMessage(messages.reportIssue)}
        </StyledDiv>
      </StyledButton>
    );
  }
}

export default ReportIssueButton;
